"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var BonusGift = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M10,9 L17,9 C18.1045695,9 19,9.8954305 19,11 L19,18 C19,19.1045695 18.1045695,20 17,20 L10,20 C8.8954305,20 8,19.1045695 8,18 L8,11 C8,9.8954305 8.8954305,9 10,9 Z M10,10 C9.44771525,10 9,10.4477153 9,11 L9,18 C9,18.5522847 9.44771525,19 10,19 L17,19 C17.5522847,19 18,18.5522847 18,18 L18,11 C18,10.4477153 17.5522847,10 17,10 L10,10 Z M16.5047834,9 L15.464484,9 L14.8609469,6.89521596 C14.7087166,6.36432579 14.154938,6.05736131 13.6240478,6.20959162 L6.89521596,8.13905311 C6.36432579,8.29128342 6.05736131,8.84506199 6.20959162,9.37595217 L8,15.6198482 L8,17.4993114 C7.61477513,17.2457757 7.3148769,16.8584953 7.17779142,16.3804214 L5.24832993,9.65158952 C4.94386931,8.58980917 5.55779826,7.48225203 6.61957861,7.17779142 L13.3484105,5.24832993 C14.4101908,4.94386931 15.517748,5.55779826 15.8222086,6.61957861 L16.5047834,9 L16.5047834,9 Z M11.9,14.2 L12.9624779,15.6166372 L15.0760008,12.2350005 C15.222356,12.0008323 15.5308312,11.9296457 15.7649995,12.0760008 C15.9991677,12.222356 16.0703543,12.5308312 15.9239992,12.7649995 L13.4239992,16.7649995 C13.2378563,17.0628281 12.8107282,17.0809709 12.6,16.8 L11.1,14.8 C10.9343146,14.5790861 10.9790861,14.2656854 11.2,14.1 C11.4209139,13.9343146 11.7343146,13.9790861 11.9,14.2 Z" })));
};
BonusGift.displayName = 'BonusGift';
exports.default = BonusGift;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=BonusGift.js.map